'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactIs_development = {};

exports.__exports = reactIs_development;
